import { render, staticRenderFns } from "./writtenTestDetail.vue?vue&type=template&id=258c06d6&scoped=true&"
import script from "./writtenTestDetail.vue?vue&type=script&lang=js&"
export * from "./writtenTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./writtenTestDetail.vue?vue&type=style&index=0&id=258c06d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258c06d6",
  null
  
)

export default component.exports